import React, { useState } from "react";
import Container from "../common/Container";
import Button from "../common/Button";
import { FaCircle, FaXmark, FaCheck } from "react-icons/fa6";
import { site } from "../../data/siteData";
import "../../styles/About.css";

export default function About() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const points = [
    "Advanced technology & equipment for premium hygiene outcomes.",
    "Highly trained professionals with rigorous verification.",
    "Tailored service plans built around your facility needs.",
    "Compliance, risk management, and complete peace of mind.",
  ];

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    if (!isModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  };

  return (
    <section id="about" className="about-section">
      <Container>
        <div className="about-grid">
          <div className="about-image-container">
            <div className="image-wrapper">
              <img
                src={site.images.about || "/about-cleaner.jpg"}
                alt="Crown Star Facility Services"
                className="main-about-image"
              />
              <div className="experience-badge">
                <span className="vertical-text">15 + Years Experience</span>
              </div>
            </div>
          </div>

          <div className="about-content">
            <span className="sub-badge">About Us</span>
            <h2 className="about-title">
              Beyond Cleaning. <br /> Defined by Excellence.
            </h2>

            <p className="about-desc">
              Crown Star Facility Services is a Western Australia–based provider
              of premium facility services, established with one objective: to
              deliver consistently superior standards of cleanliness, hygiene,
              and asset care.
            </p>

            <ul className="about-list">
              {points.map((point, index) => (
                <li key={index}>
                  <FaCircle className="list-icon" />
                  <span>{point}</span>
                </li>
              ))}
            </ul>

            <div className="about-action">
              <Button onClick={toggleModal} variant="primary" className="btn-premium">
                About More
              </Button>
            </div>
          </div>
        </div>
      </Container>

      {isModalOpen && (
        <div className="about-modal-overlay" onClick={toggleModal}>
          <div className="about-modal-card" onClick={(e) => e.stopPropagation()}>
            <button className="about-modal-close" onClick={toggleModal}>
              <FaXmark />
            </button>

            <div className="about-modal-body">
              <div className="modal-header-img">
                <img src={site.images.hero2} alt="Crown Star Facility Services" />
                <div className="header-overlay">
                  <h3>Our Standard</h3>
                </div>
              </div>

              <div className="modal-scroll-content">
                <h4>Beyond Cleaning. Defined by Excellence.</h4>
                <p>
                  Crown Star Facility Services is a Western Australia–based provider of
                  premium facility services, established with a singular objective:
                  to deliver consistently superior standards of cleanliness, hygiene,
                  and asset care.
                </p>
                <p>
                  Over the past 15 years, we have evolved from a local operation into a
                  respected name in professional facility services—trusted by clients
                  who value precision, discretion, and uncompromising quality.
                </p>

                <div className="modal-info-grid">
                  <div className="info-box">
                    <h5>Our Vision</h5>
                    <p>
                      To be recognised as Western Australia’s most trusted provider of
                      premium, corporate-grade facility services.
                    </p>
                  </div>
                  <div className="info-box">
                    <h5>Our Mission</h5>
                    <p>
                      To deliver meticulously maintained environments through innovation,
                      structured systems, and exceptional attention to detail—setting a
                      benchmark for quality in the facility services industry.
                    </p>
                  </div>
                </div>

                <h4>The Crown Star Standard</h4>
                <p>
                  Cleaning is only one component of a broader, more disciplined service
                  philosophy. We maintain environments to the highest professional and
                  hygienic standards—ensuring they remain safe, presentable, and
                  operationally efficient.
                </p>

                <h4>Our Distinction</h4>
                <ul className="detailed-list">
                  <li>
                    <FaCheck /> <strong>Advanced Technology & Equipment:</strong> We deploy
                    hospital-grade HEPA filtration systems and professional microfiber
                    technology to remove fine particulates, allergens, and contaminants.
                  </li>
                  <li>
                    <FaCheck /> <strong>Highly Trained Professionals:</strong> All personnel
                    undergo a rigorous 50-point background verification process and ongoing
                    training in specialised janitorial and facility practices.
                  </li>
                  <li>
                    <FaCheck /> <strong>Tailored Service Plans:</strong> Every facility is
                    assessed individually. We design service programs aligned with usage,
                    foot traffic, and operational requirements.
                  </li>
                  <li>
                    <FaCheck /> <strong>Compliance & Risk Management:</strong> Fully insured
                    and compliant with relevant Australian workplace health, safety, and
                    environmental regulations—ensuring peace of mind at every level.
                  </li>
                </ul>

                <h4>Sustainability with Purpose</h4>
                <p>
                  Environmental responsibility is embedded in our operational framework.
                  Through our Green Clean Initiative, we implement responsible solutions
                  that reduce chemical exposure, conserve water, and support healthier
                  indoor environments—without compromising performance.
                </p>

                <h4>Premium Care Across Every Environment</h4>
                <p>
                  From executive office suites and commercial towers to high-end residential
                  developments, Crown Star Facility Services delivers a consistent, refined
                  level of service defined by professionalism, discretion, and reliability.
                </p>

                <p>
                  <strong>Crown Star Facility Services</strong>
                  <br />
                  “Where environments are maintained to a higher standard”
                </p>
              </div>

              <div className="modal-footer">
                <Button onClick={toggleModal} variant="outline">
                  Close Details
                </Button>
                <Button as="a" href="#contact" variant="primary" onClick={toggleModal}>
                  Get Started Now
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
